exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.expandable[data-v-75c5ca20] {\n  overflow: hidden;\n}\n", "", {"version":3,"sources":["/Users/bryllec/Code/habithealth/resources/assets/frontend/js/components/Expandable.vue"],"names":[],"mappings":";AAAA;EACE,iBAAiB;CAAE","file":"Expandable.vue","sourcesContent":[".expandable {\n  overflow: hidden; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75c5ca20","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/components/Expandable.vue
// module id = ./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-75c5ca20","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/components/Expandable.vue
// module chunks = 0